import React, { useState } from "react";
import classes from "../login/login.module.css";
import {
   Box,
   TextField,
   Button,
   InputAdornment,
   IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UrbcLogo from "../../../components/urbc-logo/urbc-logo";
import { Link } from "react-router-dom";

const ResetPassword = () => {
   const [showPassword, setShowPassword] = useState(false);
   const handleClickShowPassword = () => {
      setShowPassword((showPassword) => !showPassword);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
   };
   return (
      <Box className={classes.login}>
         <Box className={classes.loginForm}>
            <form onSubmit={handleSubmit}>
               <Box className={classes.Form}>
                  <Box>
                     <UrbcLogo />
                  </Box>
               </Box>
               <Box className={classes.Email}>
                  <TextField
                     type="text"
                     sx={{ background: "white" }}
                     variant="outlined"
                     label="Enter token"
                     fullWidth
                  />
               </Box>
               <Box className={classes.Password}>
                  <TextField
                     id="input-with-icon-textfield"
                     sx={{ background: "white" }}
                     type={showPassword ? "text" : "password"}
                     label="Password"
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPassword}
                                 edge="end"
                              >
                                 {showPassword ? (
                                    <VisibilityOff />
                                 ) : (
                                    <Visibility />
                                 )}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     variant="outlined"
                     fullWidth
                  />
               </Box>
               <Box className={classes.Password}>
                  <TextField
                     id="input-with-icon-textfield"
                     sx={{ background: "white" }}
                     type={showPassword ? "text" : "password"}
                     label="Confirm password"
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPassword}
                                 edge="end"
                              >
                                 {showPassword ? (
                                    <VisibilityOff />
                                 ) : (
                                    <Visibility />
                                 )}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     variant="outlined"
                     fullWidth
                  />
               </Box>
               <Box className={classes.Button}>
                  <Button
                     sx={{ background: "#001A72" }}
                     className={classes.loginButton}
                     type="submit"
                     variant="contained"
                  >
                     Login
                  </Button>
                  <p>
                     Back to <Link to="/login">Login</Link>
                  </p>
               </Box>
            </form>
         </Box>
      </Box>
   );
};

export default ResetPassword;
